import { memo } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import useAnalytics from "effect/use_analytics";

// -----------------------------------------------------------------------------

const CheckEmailPage = memo(function CheckEmailPage(): JSX.Element {
  useAnalytics("Meta: Check Email for Login");

  //
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        maxWidth: "100%",
        margin: "auto",
      }}
    >
      <Typography variant="h3" sx={{ mt: 3, mb: 3, textAlign: "center" }}>
        Check Your Email
      </Typography>

      <Typography variant="body1" sx={{ textAlign: "center" }}>
        We emailed a login link to your email. You can close this window.
      </Typography>
    </Box>
  );
});

export default CheckEmailPage;
